import type { StaffBootstrap } from "@/hooks/use-staff";
import type { PayLine } from "./use-staff-pay";
import { staffPositionName } from "./staff-finishing-language";
import { step11Text } from "./staff-step11-language";
import { overtimeTypes } from "./staff-overtime";
import { staffDate } from "@/lib/staff-identity";

type PositionPerson={id:string;positionId?:string|null;positionName?:string|null;positionNameAr?:string|null};
export type StaffPositionDisplayData=Pick<StaffBootstrap,"employees"|"positions">;
// Bootstrap is used only for display names, never eligibility or payment authority.
export function staffDisplayPosition(person:PositionPerson|undefined,bootstrap:StaffPositionDisplayData|undefined,rtl:boolean){
  if(!person)return "";
  const positionId=person.positionId||bootstrap?.employees.find(p=>p.id===person.id)?.positionId;
  const position=bootstrap?.positions.find(p=>p.id===positionId);
  return staffPositionName({positionName:person.positionName||position?.name,positionNameAr:person.positionNameAr||position?.nameAr},rtl);
}
export function staffDisplayOvertime(line:PayLine,rtl:boolean){
  if(line.kind!=="extra"||!line.overtimeType||!overtimeTypes[line.overtimeType]||line.overtimeQty==null||!line.overtimeDate)return line.label;
  const type=overtimeTypes[line.overtimeType],quantity=Number(line.overtimeQty);
  const unit=type.unit==="hours"?(quantity===1?"hour":"hours"):(quantity===1?"day":"days");
  const quantityText=rtl?type.unit==="hours"?`${quantity} ${step11Text("hours",true)}`:step11Text(`${quantity} days`,true):`${quantity} ${unit}`;
  return [step11Text(rtl?"overtime":"Overtime",rtl),step11Text(type.name,rtl),quantityText,line.overtimeDate?staffDate(line.overtimeDate,rtl):""].filter(Boolean).join(" · ");
}
